<template>
  <div class="content">
    <!-- <PageHeader :title="`${$t('login-invite.welcome-login')},`" :accName="name" /> -->
    <header class="page-header">
      <div class="d-flex align-items-center">
        <div class="mr-auto">
          <h1 class="text-capitalize">
            <span class="title title-home">{{ $t('login-invite.welcome-login') }},</span>
            <span class="acc-title">{{ name }}</span>
          </h1>
        </div>
      </div>
    </header>
    <div class="page-content container-fluid">
      <div class="row">
        <!-- Left -->
        <div :class="{ 'col-lg-12': !isMainWhitelabel }" class="col-lg-9">
          <div class="container-fluid">
            <div class="row infos-wrapper mb-1">
              <div class="card-deck card-deck-infos">
                <!-- Billing Card -->
                <div class="card">
                  <div class="container-fluid">
                    <router-link to="/billing">
                      <div class="row">
                        <div class="col-2 left-info-div" style="display: flex; align-items: center">
                          <div class="infos-desc">
                            <span class="material-icons-outlined icon_title">account_balance</span>
                          </div>
                        </div>
                        <div class="col col-lg">
                          <div class="infos-desc">
                            <strong class="title">{{ $t('generic-str.limit') }}/{{ $t('generic-str.funds') }}</strong
                            ><!-- Saldo da Conta -->
                            <div class="w-100"></div>
                            <p v-if="account.balance" class="mb-0">
                              {{ account.balance | currency }}
                            </p>
                            <p v-else class="mb-0 w-75 animated-background"></p>
                          </div>
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>
                <!--/Billing Card -->
                <!-- Users Counter Card -->
                <div class="card">
                  <div class="container-fluid">
                    <router-link to="/users">
                      <!-- <div v-if="users" class="row">
                        <img src="@/assets/loading.gif" alt="yupchat loading" class="loading-icon" />
                        <LoadingAnim />
                      </div> -->
                      <div class="row">
                        <div class="col-2 left-info-div" style="display: flex; align-items: center">
                          <div class="card-body">
                            <span class="material-symbols-outlined thin-icon icon_title text-yup">supervisor_account</span>
                          </div>
                        </div>
                        <div class="col col-lg d-flex align-items-center">
                          <div class="card-body">
                            <strong class="title">{{ $tc('generic-str.user', 2) }}</strong
                            ><!-- Usuários -->
                            <div class="w-100"></div>
                            <p v-if="users" class="mb-0 text-yup">
                              {{ users }}
                            </p>
                            <p v-else class="mb-0 w-75 animated-background"></p>
                          </div>
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>
                <!-- API Link -->
                <div class="card api-card">
                  <div class="container-fluid">
                    <a :href="docUrl" target="_blank">
                      <div class="row">
                        <div class="col-2 pr-0" style="display: flex; align-items: center">
                          <div class="card-body">
                            <span class="material-icons-outlined icon_title text-yup">
                              cloud_queue
                            </span>
                          </div>
                        </div>
                        <div class="col col-lg">
                          <div class="card-body">
                            <strong class="title">{{ $t('home.api-div.title') }}</strong>
                            <div class="w-100"></div>
                            <p class="mb-0 text-yup">
                              {{ $t('home.api-div.string') }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
                <!--/API Link -->
              </div>
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-lg-12 col-xl-6">
              <CardComponent>
                <!-- Informações da conta -->
                <template #header>
                  {{ $t('home.acc.title') }}
                </template>
                <form action="#" class="form-horizontal">
                  <div class="form-body">
                    <FormGroup :label="$t('home.acc.label')" row>
                      <FormInput v-model="account.name" readonly />
                    </FormGroup>
                    <FormGroup :label="$t('home.acc.lbl-id')" row>
                      <FormInput v-model="account.id" readonly />
                    </FormGroup>
                    <FormGroup v-if="['admin', 'owner', 'developer'].includes($store.state.auth.user.role)" label="AUTH TOKEN" row>
                      <HiddenInput :readonly="true" :value="account.auth_token" title="Token de autenticação" />
                    </FormGroup>
                  </div>
                </form>
              </CardComponent>
            </div>
            <div class="col-lg-12 col-xl-6">
              <InviteCard />
            </div>
          </div>
          <div v-if="hasOmniPlan" class="row">
            <div class="col-12 col-sm-6">
              <div class="card card-chart">
                <!-- <chart format="pie" title="Omni Business" :data="dataTabs" :loading="loadingTabs" /> -->
                <chart :data="dataTabs" :loading="loadingTabs" format="pie" title="Chat" />
              </div>
            </div>
            <div class="col-12 col-sm-6">
              <!-- <status-messages-chart ref="statusMessages" :start-date="'2023-05-01'" :end-date="'2023-05-31 23:59:59'" /> -->
              <div class="card card-chart">
                <chart :data="dataSms" :fetchSms="true" :loading="loadingTabs" :title="$tc('app.campaign', 2)" format="pie" />
              </div>
              <!-- <StatusChart /> -->
            </div>
          </div>
          <!-- Chart -->
          <!-- <div class="row mb-1 chart_row">
            <div class="col-lg-12 col-xl-6">
              <omni-chart-card />
            </div>
            <div class="col-lg-12 col-xl-6">
              <div class="card">
                <div class="card-header">{{ $t('sms.campaigns.header') }}</div>
                <div class="card-body">
                  <AreaChartSplineExample />
                </div>
              </div>
            </div>
          </div> -->
        </div>
        <!-- Right -->
        <div v-if="isMainWhitelabel" class="col-lg-3">
          <!-- SMS Lottie -->
          <div class="card lottie_card sms sms_lottie">
            <div class="card-header">
              <p>{{ $t('home.sms-card.title') }}</p>
              <!--<p class="ml-auto">
                R$65,00<br/><span>{{ $t('app.fromMonth') }}</span>
              </p>-->
            </div>
            <div class="card-body">
              <!-- <div class="svg-lottie"><LottieAnimSms /></div> -->
              <p>{{ $t('home.sms-card.desc') }}</p>
              <button class="btn">Upgrade</button>
              <small>{{ $t('home.sms-card.inline-list') }}</small>
            </div>
          </div>
          <!--/SMS Lottie -->
          <!-- WhatsApp Lottie -->
          <div class="card lottie_card wpp wpp_lottie">
            <div class="card-header">
              <p>{{ $t('home.wpp-card.title') }}</p>
              <!--<p class="ml-auto">
                R$199,00<br/><span>{{ $t('app.fromMonth') }}</span>
              </p>-->
            </div>
            <div class="card-body">
              <!-- <div class="svg-lottie"><LottieAnimWpp /></div> -->
              <p>{{ $t('home.wpp-card.desc') }}</p>
              <button class="btn">Upgrade</button>
              <small>{{ $t('home.wpp-card.inline-list') }}</small>
            </div>
          </div>
          <!--/WhatsApp Lottie -->
          <!-- Omni Lottie -->
          <div class="card lottie_card omni">
            <div class="card-header">
              <p>{{ $t('home.omni-card.title') }}</p>
              <!--<p class="ml-auto">
                R$599,90<br/><span>{{ $t('app.fromMonth') }}</span>
              </p>-->
            </div>
            <div class="card-body">
              <ul class="list-unstyled">
                <li>
                  <svg class="icon-products" fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
                    <g id="wpp-icon">
                      <path
                        id="whatsapp-brands"
                        clip-rule="evenodd"
                        d="M16.6374 3.08872C14.8785 1.32565 12.5361 0.355957 10.0469 0.355957C4.90875 0.355957 0.72776 4.53696 0.72776 9.67506C0.72776 11.3164 1.15593 12.92 1.97031 14.3346L0.64801 19.1621L5.58881 17.8649C6.94889 18.6079 8.48109 18.9983 10.0427 18.9983H10.0469C15.1808 18.9983 19.4541 14.8174 19.4541 9.67926C19.4541 7.18997 18.3963 4.85179 16.6374 3.08873L16.6374 3.08872ZM10.0469 17.4284C8.65318 17.4284 7.2889 17.0547 6.10093 16.3495L5.81968 16.1816L2.88962 16.9498L3.67041 14.0911L3.48571 13.7973C2.70912 12.5631 2.30193 11.1401 2.30193 9.67506C2.30193 5.4059 5.7777 1.93013 10.0511 1.93013C12.1206 1.93013 14.0641 2.73611 15.525 4.20114C16.9858 5.66617 17.8841 7.60974 17.8799 9.67926C17.8799 13.9526 14.316 17.4284 10.0469 17.4284L10.0469 17.4284ZM14.295 11.627C14.0641 11.5095 12.9181 10.947 12.7041 10.8714C12.49 10.7917 12.3347 10.7539 12.1793 10.9889C12.024 11.224 11.5791 11.7446 11.4405 11.9041C11.3062 12.0594 11.1677 12.0804 10.9368 11.9628C9.5683 11.2786 8.66997 10.7413 7.76745 9.1923C7.52818 8.78092 8.00672 8.8103 8.45169 7.92037C8.52725 7.76505 8.48947 7.63072 8.4307 7.51319C8.37193 7.39565 7.90598 6.24965 7.71288 5.7837C7.52398 5.33033 7.33088 5.39331 7.18816 5.38491C7.05383 5.37652 6.89851 5.37652 6.74319 5.37652C6.58787 5.37652 6.33601 5.43529 6.12192 5.66616C5.90783 5.90124 5.30755 6.46374 5.30755 7.60974C5.30755 8.75574 6.14291 9.86396 6.25625 10.0193C6.37379 10.1746 7.89758 12.5253 10.2358 13.537C11.7134 14.1751 12.2927 14.2296 13.0315 14.1205C13.4806 14.0533 14.4083 13.558 14.6014 13.0123C14.7945 12.4666 14.7946 12.0006 14.7358 11.9041C14.6812 11.7991 14.5259 11.7404 14.295 11.627Z"
                        fill="white"
                        fill-rule="evenodd"
                      />
                    </g>
                  </svg>
                  <span class="material-symbols-outlined"> add </span>
                </li>
                <li>
                  <svg fill="none" height="16" viewBox="0 0 20 16" width="20" xmlns="http://www.w3.org/2000/svg">
                    <g id="email-icon">
                      <path
                        id="mail_FILL0_wght400_GRAD0_opsz48"
                        clip-rule="evenodd"
                        d="M1.54545 15.1582C1.16747 15.1582 0.836731 15.0165 0.553251 14.733C0.269761 14.4495 0.128021 14.1188 0.128021 13.7408V1.45637C0.128021 1.07839 0.269761 0.74765 0.553251 0.46417C0.836741 0.18068 1.16747 0.0389404 1.54545 0.0389404H17.6097C17.9876 0.0389404 18.3184 0.18068 18.6019 0.46417C18.8854 0.74766 19.0271 1.07839 19.0271 1.45637V13.7408C19.0271 14.1188 18.8854 14.4495 18.6019 14.733C18.3184 15.0165 17.9876 15.1582 17.6097 15.1582H1.54545ZM9.95553 7.76394L17.6097 2.75568V13.7408H1.54545V2.75568L9.19957 7.76394C9.26257 7.79544 9.32163 7.823 9.37675 7.84662C9.43187 7.87025 9.49881 7.88206 9.57755 7.88206C9.65629 7.88206 9.72323 7.87025 9.77835 7.84662C9.83347 7.823 9.89253 7.79544 9.95553 7.76394ZM17.5152 1.45637L9.57755 6.60637L1.66357 1.45637H17.5152Z"
                        fill="white"
                        fill-rule="evenodd"
                      />
                    </g>
                  </svg>
                  <span class="material-symbols-outlined"> add </span>
                </li>
                <li>
                  <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
                    <g id="omni-icon">
                      <g id="webchat">
                        <path
                          id="omni-brands"
                          clip-rule="evenodd"
                          d="M16.8306 3.7527C15.0563 1.97416 12.6934 0.995972 10.1823 0.995972C4.99911 0.995972 0.781439 5.21364 0.781439 10.3968C0.781439 12.0526 1.21337 13.6702 2.03489 15.0972L0.700989 19.967L5.68513 18.6585C7.05714 19.4081 8.60278 19.8019 10.178 19.8019H10.1823C15.3612 19.8019 19.6721 15.5842 19.6721 10.4011C19.6721 7.88993 18.6049 5.53125 16.8306 3.7527H16.8306ZM10.1823 18.2182C8.77639 18.2182 7.40014 17.8413 6.20174 17.1299L5.91802 16.9605L2.96226 17.7354L3.7499 14.8516L3.56358 14.5552C2.78018 13.3102 2.36942 11.8747 2.36942 10.3968C2.36942 6.09021 5.87568 2.58395 10.1865 2.58395C12.2742 2.58395 14.2348 3.397 15.7084 4.87489C17.1821 6.35277 18.0883 8.3134 18.0841 10.4011C18.0841 14.7119 14.4889 18.2182 10.1823 18.2182V18.2182Z"
                          fill="white"
                          fill-rule="evenodd"
                        />
                        <g id="Group 12306">
                          <mask id="mask0_101_4018" height="12" maskUnits="userSpaceOnUse" style="mask-type: luminance" width="12" x="4" y="5">
                            <path id="Rectangle 3341" clip-rule="evenodd" d="M4.95999 5.38892H15.4144V16.4668H4.95999V5.38892Z" fill="white" fill-rule="evenodd" />
                          </mask>
                          <g mask="url(#mask0_101_4018)">
                            <path
                              id="Path 1198"
                              clip-rule="evenodd"
                              d="M11.2327 14.6615C9.73918 11.575 8.34525 8.48839 6.95132 5.40186H4.95999L9.14178 14.6615H6.15479L6.95132 16.4537H10.3366L11.2327 14.6615Z"
                              fill="white"
                              fill-rule="evenodd"
                            />
                            <path
                              id="Path 1199"
                              clip-rule="evenodd"
                              d="M12.527 7.29359H8.74352C8.44479 6.59666 8.24566 5.99926 7.94699 5.40186C10.4361 5.40186 12.9253 5.40186 15.4144 5.40186L11.6309 13.5663C11.3322 12.8693 11.0335 12.1724 10.6353 11.3758C11.3323 9.98192 11.9297 8.68753 12.527 7.2936V7.29359Z"
                              fill="white"
                              fill-rule="evenodd"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                  <span class="material-symbols-outlined"> add </span>
                </li>
                <li>
                  <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
                    <g id="icon">
                      <g id="Group 12618">
                        <path
                          id="menssager"
                          clip-rule="evenodd"
                          d="M16.4747 3.7527C14.7004 1.97416 12.3374 0.995972 9.82632 0.995972C4.64315 0.995972 0.425482 5.21364 0.425482 10.3968C0.425482 12.0526 0.857412 13.6702 1.67893 15.0972L0.345032 19.967L5.32917 18.6585C6.70118 19.4081 8.24682 19.8019 9.82209 19.8019H9.82633C15.0053 19.8019 19.3161 15.5842 19.3161 10.4011C19.3161 7.88993 18.249 5.53125 16.4747 3.7527H16.4747ZM9.82632 18.2182C8.42043 18.2182 7.04418 17.8413 5.84578 17.1299L5.56206 16.9605L2.6063 17.7354L3.39394 14.8516L3.20762 14.5552C2.42422 13.3102 2.01346 11.8747 2.01346 10.3968C2.01346 6.09021 5.51972 2.58395 9.83056 2.58395C11.9182 2.58395 13.8789 3.397 15.3525 4.87489C16.8261 6.35277 17.7323 8.3134 17.7281 10.4011C17.7281 14.7119 14.1329 18.2182 9.82632 18.2182V18.2182Z"
                          fill="white"
                          fill-rule="evenodd"
                        />
                        <g id="Brand Logos">
                          <path
                            id="Path 1201"
                            clip-rule="evenodd"
                            d="M5.62335 13.6031C5.28031 13.6025 4.96859 13.4035 4.82372 13.0925C4.67885 12.7816 4.727 12.4149 4.94723 12.1519L7.64463 8.93833C7.92526 8.6009 8.41158 8.52173 8.78475 8.75273L11.742 10.5699L13.7854 8.13494C14.0989 7.76084 14.6564 7.71196 15.0303 8.02564C15.4043 8.33932 15.4532 8.89679 15.1395 9.27076L12.6055 12.2897C12.3241 12.6253 11.8395 12.7042 11.4663 12.4753L8.50902 10.6582L6.30126 13.2876C6.13357 13.4884 5.88505 13.6041 5.62337 13.6031L5.62335 13.6031Z"
                            fill="white"
                            fill-rule="evenodd"
                          />
                        </g>
                      </g>
                    </g>
                  </svg>
                  <span class="material-symbols-outlined"> add </span>
                </li>
                <li>
                  <svg fill="none" height="19" viewBox="0 0 20 19" width="20" xmlns="http://www.w3.org/2000/svg">
                    <g id="icon">
                      <g id="Group 12825">
                        <path
                          id="sms_FILL0_wght400_GRAD0_opsz48"
                          clip-rule="evenodd"
                          d="M0.990967 17.6101V2.28082C0.990967 1.92895 1.12866 1.6115 1.40404 1.32847C1.67942 1.04544 2.00069 0.903931 2.36786 0.903931H17.9725C18.3244 0.903931 18.6419 1.04544 18.9249 1.32847C19.2079 1.6115 19.3494 1.92894 19.3494 2.28082V14.2138C19.3494 14.5657 19.2079 14.8831 18.9249 15.1662C18.6419 15.4492 18.3244 15.5907 17.9725 15.5907H4.66267L2.16133 18.092C1.94715 18.3062 1.69854 18.3559 1.41552 18.2412C1.13249 18.1265 0.990977 17.9161 0.990977 17.6101H0.990967Z"
                          fill="white"
                          fill-rule="evenodd"
                        />
                        <path
                          id="Path 1234"
                          clip-rule="evenodd"
                          d="M5.39677 9.99057V9.20011C5.54004 9.32033 5.69566 9.41049 5.86364 9.4706C6.03161 9.53071 6.20123 9.56076 6.3725 9.56076C6.47295 9.56076 6.56065 9.5517 6.63558 9.53359C6.71051 9.51548 6.77309 9.49036 6.82331 9.45825C6.87354 9.42614 6.911 9.38826 6.9357 9.34462C6.9604 9.30098 6.97275 9.25363 6.97275 9.20258C6.97275 9.13341 6.95299 9.07166 6.91347 9.01732C6.87395 8.96298 6.82001 8.91275 6.75167 8.86664C6.68333 8.82053 6.60222 8.77607 6.50836 8.73325C6.41449 8.69043 6.31321 8.64679 6.20453 8.60233C5.92787 8.48706 5.72161 8.34625 5.58575 8.17993C5.44989 8.0136 5.38196 7.8127 5.38196 7.5772C5.38196 7.39276 5.41901 7.23426 5.49312 7.10169C5.56723 6.96912 5.66809 6.86002 5.79572 6.77439C5.92335 6.68876 6.07115 6.62577 6.23912 6.58542C6.40709 6.54507 6.58495 6.5249 6.77268 6.5249C6.95712 6.5249 7.12057 6.53602 7.26301 6.55825C7.40546 6.58048 7.53679 6.61465 7.65701 6.66076V7.39935C7.59773 7.35818 7.53309 7.32195 7.4631 7.29066C7.39311 7.25937 7.32106 7.23343 7.24696 7.21285C7.17285 7.19227 7.09916 7.17703 7.02588 7.16715C6.9526 7.15727 6.88302 7.15233 6.81715 7.15233C6.72658 7.15233 6.64424 7.16098 6.57013 7.17827C6.49602 7.19556 6.43345 7.21985 6.3824 7.25114C6.33135 7.28243 6.29183 7.31989 6.26383 7.36353C6.23583 7.40717 6.22184 7.45616 6.22184 7.51051C6.22184 7.56979 6.23748 7.6229 6.26877 7.66984C6.30006 7.71677 6.34452 7.76124 6.40216 7.80323C6.4598 7.84522 6.52979 7.88639 6.61213 7.92674C6.69447 7.96709 6.78751 8.00867 6.89126 8.05148C7.03288 8.11076 7.1601 8.17375 7.2729 8.24045C7.3857 8.30715 7.48245 8.38249 7.56315 8.46647C7.64384 8.55046 7.7056 8.64638 7.74841 8.75425C7.79123 8.86211 7.81263 8.98768 7.81264 9.13095C7.81264 9.32857 7.77518 9.49448 7.70025 9.62869C7.62532 9.7629 7.52363 9.87159 7.39518 9.95476C7.26673 10.0379 7.11728 10.0976 6.94684 10.1339C6.7764 10.1701 6.59648 10.1882 6.4071 10.1882C6.21278 10.1882 6.02793 10.1717 5.85254 10.1388C5.67716 10.1059 5.52524 10.0565 5.39679 9.99058L5.39677 9.99057ZM12.4319 10.1264H11.6439V8.00701C11.6439 7.77811 11.6538 7.52532 11.6735 7.24866H11.6538C11.6126 7.46604 11.5755 7.62248 11.5426 7.718L10.7126 10.1264H10.0605L9.21568 7.74271C9.19262 7.67849 9.15557 7.51381 9.10452 7.24867H9.08229C9.1037 7.59779 9.1144 7.90409 9.1144 8.16758V10.1264H8.39557V6.58419H9.56397L10.2877 8.68385C10.3454 8.85182 10.3874 9.02062 10.4137 9.19024H10.4285C10.473 8.99427 10.5199 8.82383 10.5693 8.67891L11.2931 6.58419H12.4319V10.1264ZM13.0741 9.99057V9.20011C13.2174 9.32033 13.373 9.41049 13.541 9.4706C13.709 9.53071 13.8786 9.56076 14.0498 9.56076C14.1503 9.56076 14.238 9.5517 14.3129 9.53359C14.3879 9.51548 14.4504 9.49036 14.5007 9.45825C14.5509 9.42614 14.5883 9.38826 14.6131 9.34462C14.6378 9.30098 14.6501 9.25363 14.6501 9.20258C14.6501 9.13341 14.6303 9.07166 14.5908 9.01732C14.5513 8.96298 14.4974 8.91275 14.429 8.86664C14.3607 8.82053 14.2796 8.77607 14.1857 8.73325C14.0918 8.69043 13.9906 8.64679 13.8819 8.60233C13.6052 8.48706 13.399 8.34625 13.2631 8.17993C13.1272 8.0136 13.0593 7.8127 13.0593 7.5772C13.0593 7.39276 13.0964 7.23426 13.1705 7.10169C13.2446 6.96912 13.3454 6.86002 13.4731 6.77439C13.6007 6.68876 13.7485 6.62577 13.9165 6.58542C14.0844 6.54507 14.2623 6.5249 14.45 6.5249C14.6345 6.5249 14.7979 6.53602 14.9404 6.55825C15.0828 6.58048 15.2141 6.61465 15.3343 6.66076V7.39935C15.2751 7.35818 15.2104 7.32195 15.1404 7.29066C15.0704 7.25937 14.9984 7.23343 14.9243 7.21285C14.8502 7.19227 14.7765 7.17703 14.7032 7.16715C14.6299 7.15727 14.5604 7.15233 14.4945 7.15233C14.4039 7.15233 14.3216 7.16098 14.2475 7.17827C14.1734 7.19556 14.1108 7.21985 14.0597 7.25114C14.0087 7.28243 13.9692 7.31989 13.9412 7.36353C13.9132 7.40717 13.8992 7.45616 13.8992 7.51051C13.8992 7.56979 13.9148 7.6229 13.9461 7.66984C13.9774 7.71677 14.0219 7.76124 14.0795 7.80323C14.1371 7.84522 14.2071 7.88639 14.2895 7.92674C14.3718 7.96709 14.4648 8.00867 14.5686 8.05148C14.7102 8.11076 14.8374 8.17375 14.9502 8.24045C15.063 8.30715 15.1598 8.38249 15.2405 8.46647C15.3212 8.55046 15.3829 8.64638 15.4257 8.75425C15.4686 8.86211 15.49 8.98768 15.49 9.13095C15.49 9.32857 15.4525 9.49448 15.3776 9.62869C15.3026 9.7629 15.201 9.87159 15.0725 9.95476C14.9441 10.0379 14.7946 10.0976 14.6242 10.1339C14.4537 10.1701 14.2738 10.1882 14.0844 10.1882C13.8901 10.1882 13.7052 10.1717 13.5299 10.1388C13.3545 10.1059 13.2026 10.0565 13.0741 9.99058V9.99057Z"
                          fill="white"
                          fill-rule="evenodd"
                        />
                      </g>
                    </g>
                  </svg>
                </li>
              </ul>
              <p>{{ $t('home.omni-card.desc') }}</p>
              <button class="btn">Upgrade</button>
              <small>{{ $t('home.omni-card.inline-list') }}</small>
            </div>
          </div>
          <!--/Omni Lottie -->
        </div>
        <!-- <div class="col-lg-12 col-xl-4">
          <div class="card">
            <div class="card-header">SMS</div>
            <div class="card-body">
              <messages-chart ref="chart" :days="'30'" />
            </div>
            <div class="card-footer d-flex justify-content-between">
              <router-link
                to="/sms/dashboard"
                class="btn btn-secondary btn-outline"
                >SMS</router-link
              >
              <router-link
                to="/sms/history"
                class="btn btn-secondary btn-outline"
                >{{ $t('generic-str.menu.history') }}</router-link
              >
            </div>
          </div>
          <div v-if="$store.state.stage <= 0" class="card">
            <div class="card-header">Whitelabel</div>
            <div class="card-body">
              Crie um contact center omnichannel em questão de minutos e
              personalize todos os elementos da experiência.
            </div>
            <div class="card-footer">
              <button type="button" class="btn btn-secondary btn-outline">
                Whitelabel
              </button>
            </div>
          </div>
        </div> -->
        <div class="col-lg-12 col-xl-4">
          <div v-if="$store.state.stage <= 0" class="card">
            <div class="card-header">{{ $t('generic-str.voice') }}</div>
            <div class="card-body">
              <ul class="list-group">
                <li class="list-group-item d-flex justify-content-between align-items-center">
                  {{ $t('home.conf-call') }}
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">{{ $t('home.msg') }} x</li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                  {{ $t('home.control') }}
                </li>
              </ul>
            </div>
            <div class="card-footer">
              <button class="btn btn-secondary btn-outline" type="button">
                {{ $t('generic-str.voice') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from '@/services/user.service';
import FormGroup from '@/components/form/FormGroup.vue';
import FormInput from '@/components/form/FormInput.vue';
import InviteCard from '@/components/InviteCard.vue';
import HiddenInput from '@/components/HiddenInput.vue';
import Chart from '@/components/rebranding/apexcharts/Chart.vue';
import moment from 'moment';
import CardComponent from '@/components/CardComponent.vue';

export default {
  name: 'Home',
  components: {
    CardComponent,
    InviteCard,
    HiddenInput,
    FormGroup,
    FormInput,
    Chart,
  },
  props: {
    filters: {
      type: Object,
    },
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
  },
  data() {
    return {
      sms: true,
      users: 0,
      sms_hover: true,
      wpp_hover: true,
      email_hover: true,
      accName: String,
      loadingTabs: false,
      fetchSms: false,
      dataTabs: [],
      dataSms: [],
    };
  },
  computed: {
    account() {
      return this.$store.state.account;
    },
    name() {
      return this.$store?.state?.auth?.user?.name;
    },
    timeWindow() {
      if (moment(this.endDate).diff(moment(this.startDate), 'days')) {
        return 'day';
      }
      return 'hour';
    },
    channels() {
      return this.$parent?.filters?.channels || [];
    },
    tabs() {
      return this.$parent?.filters?.tabs || [];
    },
    tags() {
      return this.$parent?.filters?.tags || [];
    },
    isMainWhitelabel() {
      return this.$store.state.admin.whitelabel.is_main;
    },
    hasOmniPlan() {
      return this.$store.state.plans.omniPlan;
    },
    docUrl() {
      let url = 'https://doc.yup.chat/';
      if (this.$store.state.admin.whitelabel.name === 'Algar') {
        url = 'https://doc.smsycorporativo.algartelecom.com.br';
      } else if (this.$store.state.admin.whitelabel.name === 'Mercafacil') {
        url = '';
      } else if (this.$store.state.admin.whitelabel.name === 'Mutant') {
        url = '';
      } else if (this.$store.state.admin.whitelabel.name === 'Pingoo') {
        url = 'https://doc.pingoo.mobi/';
      } else if (this.$store.state.admin.whitelabel.name === 'Kankei') {
        url = 'https://doc.kankei.com.br/';
      }

      return url;
    },
  },
  created() {
    this.countUsers();
    this.$root.$on('change.account', () => {
      if (this.$refs.chart) {
        this.countUsers();
        this.$refs.chart.fetch();
        this.$refs.statusMessages.fetch();
      }
    });
  },
  methods: {
    countUsers() {
      UserService.countUsers().then(
        (response) => {
          this.users = response.total;
        },
        (error) => {
          this.content = error;
        },
      );
    },
  },
};
</script>

<style lang="scss" scoped>
tbody tr {
  cursor: pointer;

  &:hover {
    background-color: #fafafa;
    /* #f0f6ff */
  }
}

.page-header {
  padding: 30px 30px 0;
  padding-bottom: 2rem;

  h1 {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    color: var(--foreground);
    padding: 7px 20px 7px 0;
    font-size: 3.2vw;

    @media (min-width: 993px) {
      font-size: 1.64vw;
    }

    .title-home {
      font-weight: 400;
    }

    .acc-title {
      font-weight: 700;
    }
  }
}

.bg-account {
  background-color: #752de6;
}

.card.sms {
  background: linear-gradient(145deg, rgba(0, 210, 255, 1) 0%, rgba(146, 141, 171, 1) 100%);
}

.card.wpp {
  background: linear-gradient(145deg, rgba(255, 95, 109, 1) 0%, rgba(255, 195, 113, 1) 100%);
}

.card.omni {
  background: linear-gradient(145deg, rgba(66, 39, 90, 1) 0%, rgba(115, 75, 109, 1) 100%);
}

.lottie_card.omni {
  .card-body {
    button.btn {
      margin-bottom: 0.75rem;
    }
  }
}

.lottie_card {
  color: #fff;
  max-height: 284px;

  @media (min-width: 1360px) and (max-width: 1600px) {
    max-height: fit-content;

    .card-header {
      flex-wrap: nowrap;

      p {
        white-space: nowrap;
      }
    }

    .card-body {
      ul {
        flex-wrap: wrap;
      }
    }
  }

  .card-header {
    p:last-of-type {
      line-height: 1rem;
      text-align: right;
      text-transform: uppercase;
    }

    p {
      margin-bottom: 0;

      span {
        font-size: 0.625rem;
      }
    }
  }

  .card-body {
    p {
      line-height: 24px;
      text-align: center;
    }
  }

  p {
    color: inherit;
  }

  button {
    font-weight: 400;
    width: 11rem;
    border-radius: 20px;
    background-color: #fff;
    margin-bottom: 2rem;
  }

  small {
    font-size: 0.625rem;
    text-align: center;
  }

  ul {
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 10px;

    li {
      display: flex;
      align-items: center;

      span.material-symbols-outlined {
        margin-left: 10px;
      }
    }
  }
}

@media (min-width: 768px) {
  .second_row .card {
    height: 250px;
  }

  .rebranding img.icon_title {
    width: 38px;
  }
}

.card-deck-infos {
  width: 100%;
  margin-bottom: 2rem;
  margin-left: 0;
  margin-right: 0;
  gap: 1.857rem;
}

.card-deck-infos .card {
  flex: 0 0 23.2%;
  max-width: 50%;
  height: 100%;
  margin-left: 0;
  margin-right: 0;
}

.card-deck-infos .card:last-of-type {
  flex: 1 !important;
  margin-right: 0;
}

.infos-wrapper .card-deck .container-fluid,
.infos-wrapper .card-deck .container-fluid .row {
  height: 100%;
}

.infos-desc {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.card-chart {
  height: 470px;
}

@media (min-width: 1360px) and (max-width: 1600px) {
  .infos-desc {
    padding-left: 10px;
  }

  .left-info-div {
    padding: 0;
  }

  .second_row .card {
    height: 280px;
  }
}

/* Celular */
@media (max-width: 767.98px) {
  .card-deck.card-deck-infos {
    height: fit-content;
  }

  .card-deck.card-deck-infos .card {
    width: 100%;
    max-width: 100%;
  }

  .card-deck-infos .infos-desc {
    padding: 1.25rem;
  }

  .rebranding img.icon_title {
    width: 32px;
  }
}
</style>
